import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';
import type {
    FirstTaskRewardApi,
    FirstTaskRewardClaimRequest,
    FirstTaskRewardClaimResponse,
} from '../../first-task-reward-api';

/** Telecom 首次任务奖励领取接口实现。 */
@injectable()
export class FirstTaskRewardApiImpl extends PsHttpService implements FirstTaskRewardApi {
    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async claim(request: FirstTaskRewardClaimRequest): Promise<FirstTaskRewardClaimResponse> {
        const response = await this.post<PatSnapSuccessResponseData<FirstTaskRewardClaimResponse>>({
            url: '/credits/rewards/first-task/claim',
            data: request,
        });
        return response.data;
    }

    async reset(): Promise<void> {
        await this.post({
            url: '/credits/rewards/first-task/reset',
        });
    }
}
